export default (
  imageWidth,
  imageHeight,
  placeholderWidth,
  placeholderHeight
) => {
  let endWidth, endHeight;
  const imageRatio = imageWidth / imageHeight;
  const isPlaceholderVertical = placeholderWidth < placeholderHeight;
  const isPlaceholderHorizontal = !isPlaceholderVertical;

  // img is vertical
  if (imageWidth < imageHeight) {
    if (isPlaceholderHorizontal) {
      endHeight = placeholderHeight;
      endWidth = imageRatio * endHeight;
    } else {
      if (imageHeight < placeholderHeight) {
        endHeight = imageHeight;
        endWidth = imageWidth;
      } else {
        if (imageWidth > placeholderWidth) {
          if (placeholderWidth / imageRatio > placeholderHeight) {
            endHeight = placeholderHeight;
            endWidth = endHeight * imageRatio;
          } else {
            endWidth = placeholderWidth;
            endHeight = endWidth / imageRatio;
          }
        } else {
          endHeight = placeholderHeight;
          endWidth = imageRatio * endHeight;
        }
      }
    }
  }
  // img is horizontal
  else {
    if (isPlaceholderVertical) {
      endWidth = placeholderWidth;
      endHeight = endWidth / imageRatio;
    } else {
      if (imageWidth < placeholderWidth) {
        if (imageHeight < placeholderHeight) {
          endWidth = imageWidth;
          endHeight = imageHeight;
        } else {
          endHeight = placeholderHeight;
          endWidth = endHeight * imageRatio;
        }
      } else {
        if (
          imageHeight > placeholderHeight &&
          placeholderHeight * imageRatio <= placeholderWidth
        ) {
          endHeight = placeholderHeight;
          endWidth = endHeight * imageRatio;
        } else {
          endWidth = placeholderWidth;
          endHeight = endWidth / imageRatio;
        }
      }
    }
  }

  return {
    width: endWidth,
    height: endHeight,
  };
};
